import React from 'react';
import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';

const ACCENT = '#2C3E2D';
const BORDER = '1px solid #E2DDD8';

export type FormButtonVariant = 'contained' | 'outlined' | 'text';
export type FormButtonTheme = 'default' | 'danger' | 'success' | 'info';

const COLORS = {
  default: ACCENT,
  danger: '#D32F2F',
  success: '#2E7D32',
  info: '#1976D2',
};

export interface FormButtonProps extends Omit<MuiButtonProps, 'color'> {
  children: React.ReactNode;
  variant?: FormButtonVariant;
  theme?: FormButtonTheme;
}

export function FormButton({
  children,
  variant = 'contained',
  theme = 'default',
  sx,
  ...props
}: FormButtonProps) {
  const isContained = variant === 'contained';
  const isOutlined = variant === 'outlined';
  const buttonColor = COLORS[theme];

  return (
    <MuiButton
      {...props}
      variant={variant}
      sx={{
        borderRadius: 0,

        fontWeight: isContained ? 600 : 400,
        px: isContained ? 3 : undefined,
        ...(isContained && {
          bgcolor: buttonColor,
          color: '#fff',
          '&:hover': {
            bgcolor: theme === 'danger' ? '#B71C1C' : theme === 'info' ? '#1565C0' : '#1A2A1B',
          },
          '&:disabled': { bgcolor: '#E2DDD8', color: '#9B958F' },
        }),
        ...(isOutlined && {
          border: BORDER,
          color: '#6B6560',
          '&:hover': { bgcolor: '#FAFAF8', borderColor: BORDER },
        }),
        ...sx,
      }}
    >
      {children}
    </MuiButton>
  );
}

export default FormButton;
